import { useGlobalsStore } from '@/stores/globals'

export function IsPrinterCategory(product: any): boolean {
  if (!product) return false
  const category = String(product.printer_category || '').trim().toLowerCase()
  return category === 'printer' || category === ''
}

export function IsLeaseEligible(product: any): boolean {
  if (!IsPrinterCategory(product)) return false
  const clean_price_str = String(product?.advertising_price || '').replace(/[$,]/g, '')
  const base_price = parseFloat(clean_price_str || '0')
  return base_price > 0
}

export function IsProductCustomQuote(product: any): boolean {
  return !IsLeaseEligible(product)
}

export function IsProductQuotable(product: any): boolean {
  if (!product) return false
  if (product.is_quotable !== undefined) {
    return Boolean(product.is_quotable)
  }
  // Fallback to basic category if not populated
  return IsPrinterCategory(product)
}

export function CalculateProductMonthlyPrice(
  product: any,
  datasets_list: any[] = [],
  accessories_list: any[] = []
): number {
  if (!product || !IsProductQuotable(product)) return 0

  const store = useGlobalsStore()
  const form = store.form
  const lease_terms = store.lease_terms || []

  const clean_price_str = String(product.advertising_price || '').replace(/[$,]/g, '')
  let base_price = parseFloat(clean_price_str || '0')

  // If base advertising price is zero or unpriced, return 0 immediately
  if (base_price <= 0) {
    return 0
  }

  const active_datasets = (Array.isArray(datasets_list) && datasets_list.length > 0)
    ? datasets_list
    : (Array.isArray(product?.datasets) ? product.datasets : [])

  const active_accessories = (Array.isArray(accessories_list) && accessories_list.length > 0)
    ? accessories_list
    : (Array.isArray(product?.accessories) ? product.accessories : [])

  let accessories_price_sum = 0
  active_datasets.forEach((ds: any) => {
    if (ds.selected) {
      const acc = active_accessories.find((a: any) => a.id === ds.accessory_id)
      if (acc) {
        accessories_price_sum += parseFloat(String(acc.advertising_price || acc.price || '0').replace(/[$,]/g, ''))
      }
    }
  })
  base_price += accessories_price_sum

  const lease_term = form?.lease_term || 60
  const matching_rate = lease_terms.find(
    (rate: any) => String(rate.rate_group_id) === String(product.rate_group_id) &&
               Number(rate.term) === Number(lease_term)
  )

  let price = 0
  if (base_price > 0 && matching_rate) {
    price = base_price * Number(matching_rate.rate)
  }

  if (price <= 0) {
    return 0
  }

  const mono_cpp = parseFloat(product.mono_cpp || '0')
  const color_cpp = parseFloat(product.color_cpp || '0')

  const prints = product.prints_per_month ?? 500
  const color = product.color_volume ?? 100
  price += (prints * mono_cpp) + (color * color_cpp)

  return Math.round(price)
}
